import styled from 'styled-components';

export const LayoutMainArea = styled.div`
  /**
   * 100/56.25 == 16/9
   * We use this ratio as we base marsha's layout on video display
   */
  width: 100vw;
  height: 56.25vw;
`;
